import { gql } from "apollo-boost";

const GET_TEMP_DMS_PRODUCT_LIST = gql`
  query getTempDmsProductList($input: GetListInput) {
    getTempDmsProductList(input: $input) {
      data {
        count
        tempProductList {
          _id
          title
          barcode
          image
          isSynced
          isVendorSync
          variantCount
          status
          updatedAt
          createdAt
        }
      }
      error
      status
    }
  }
`;

export default GET_TEMP_DMS_PRODUCT_LIST;
